import { useState, useEffect } from "react";
import InputField from "../UI/InputField";

const ArchiveSearchField = (props) => {
  const [inputValue, setInputValue] = useState({ searchText: "" });

  const { searchText } = inputValue;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // this useEffect will send the input to the parent component
  // only 500 ms after the last input was inserted, to avoid
  // backend overloads
  useEffect(() => {
    const identifier = setTimeout(() => {
      props.setField(inputValue.searchText, props.inputId);
    }, 500);
    return () => {
      clearTimeout(identifier);
    };
    // eslint-disable-next-line
  }, [inputValue]);
  useEffect(() => {
    if (props.existingInput?.length) {
      setInputValue((prev) => ({
        ...prev,
        searchText: props.existingInput,
      }));
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div className="w-full">
      <InputField
        className="flex growth px-0"
        type="text"
        value={searchText}
        placeholder="Enter a search term"
        name="searchText"
        onChange={handleChange}
        noPadding={true}
      />
    </div>
  );
};
export default ArchiveSearchField;
